import { Controller, useFormContext } from "react-hook-form"
import DropdownInput from "../DropdownInput"
import styled from "styled-components"
import { TextDiv } from "../../common/Text"

const AdvertisementDropdown = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const dropdownOptions = {
    handleName: "알게 된 경로",
    options: ["SNS", "홍보물", "지인 추천", "온라인 커뮤니티", "학교", "기타"],
  }

  return (
    <RelativeDiv>
      <Controller
        control={control}
        name="advertisement"
        render={({ field: { onChange } }) => (
          <DropdownInput
            handleName={dropdownOptions.handleName}
            selectOptions={dropdownOptions.options}
            onChange={onChange}
            $isError={errors.advertisement ? true : false}
          />
        )}
      />
      {errors.advertisement && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 45,
          }}
        >
          * {errors.advertisement.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default AdvertisementDropdown

const RelativeDiv = styled.div`
  position: relative;
`
